var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.77087 8.54932C3.54394 8.54932 2.54932 9.54394 2.54932 10.7709V36.9924C2.54932 38.2193 3.54394 39.214 4.77087 39.214H43.2291C44.4561 39.214 45.4507 38.2193 45.4507 36.9924V10.7709C45.4507 9.54394 44.4561 8.54932 43.2291 8.54932H4.77087ZM0 10.7709C0 8.13599 2.13599 6 4.77087 6H43.2291C45.864 6 48 8.13599 48 10.7709V36.9924C48 39.6273 45.864 41.7633 43.2291 41.7633H4.77087C2.13599 41.7633 0 39.6273 0 36.9924V10.7709Z",
    fill: "#79C2D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 19.5114C0 18.8074 0.570684 18.2367 1.27466 18.2367H46.7253C47.4293 18.2367 48 18.8074 48 19.5114C48 20.2154 47.4293 20.786 46.7253 20.786H1.27466C0.570684 20.786 0 20.2154 0 19.5114Z",
    fill: "#79C2D8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1547 31.4568C30.1547 30.7528 30.7253 30.1822 31.4293 30.1822H36.6736C37.3776 30.1822 37.9483 30.7528 37.9483 31.4568C37.9483 32.1608 37.3776 32.7315 36.6736 32.7315H31.4293C30.7253 32.7315 30.1547 32.1608 30.1547 31.4568Z",
    fill: "#79C2D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.ac607442c82cf6f7eb7c27a979c2d27d.svg";
export { ForwardRef as ReactComponent };